import React from 'react';
import { Route, Switch } from 'react-router-dom';

import SearchBar from '../common/search/SearchBar';
import { Home, MyFiles, DistributionShare, Notifications, Settings } from '../routes';
import './main.css';

const Main = () => {
	return (
		<div className="main">
			<Route component={SearchBar} />
			<Switch>
				<Route exact path="/" component={Home} />
				<Route path="/my-files" component={MyFiles} />
				<Route path="/notifications" component={Notifications} />
				<Route path="/distributions" component={DistributionShare} />
				<Route path="/settings" component={Settings} />
				<Route component={Home} />
			</Switch>
		</div>
	);
};

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main/index.js